const TOKEN_KEY = 'vscroll_auth_token';
const USER_KEY = 'vscroll_user_info';

export const auth = {
    // Store token and user info
    login: (token, user) => {
        localStorage.setItem(TOKEN_KEY, token);
        localStorage.setItem(USER_KEY, JSON.stringify(user));
    },

    // Remove token and user info
    logout: () => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        window.location.href = '/sign-in';
    },

    // Get current token
    getToken: () => {
        return localStorage.getItem(TOKEN_KEY);
    },

    // Get current user info
    getUser: () => {
        const user = localStorage.getItem(USER_KEY);
        return user ? JSON.parse(user) : null;
    },

    // Check if user is authenticated
    isAuthenticated: () => {
        return !!localStorage.getItem(TOKEN_KEY);
    },

    // Wrapper for fetch that adds Authorization header
    fetch: async (url, options = {}) => {
        const token = localStorage.getItem(TOKEN_KEY);
        
        const headers = {
            'Content-Type': 'application/json',
            ...options.headers,
        };

        // If body is FormData, remove Content-Type to let browser set boundary
        if (options.body instanceof FormData) {
            delete headers['Content-Type'];
        }

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const config = {
            ...options,
            headers
        };

        try {
            const response = await fetch(url, config);

            // Handle 401 Unauthorized (Token expired or invalid)
            if (response.status === 401) {
                auth.logout();
                throw new Error('Session expired. Please login again.');
            }

            return response;
        } catch (error) {
            throw error;
        }
    }
};

export default auth;
